import React from 'react'
import NavBar from '../Main/NavBar'
import { useLocation } from 'react-router-dom';

const OrderConfirmation = () => {
    const location = useLocation();
    const {orderId, method, amount} = location.state || "";

  return (
    <div>
        <NavBar/>
        <div className='payment-review'>
            <h1>Sikeres Rendelés!</h1>
            <h2>Rendelés azonosító: {orderId}</h2>
            {method == 'banktransfer' && (
                <div>
                    <p>Kérjük hogy az összeget a 12094507-01372320-00100009 számlaszámra küldje el az alábbi módon:</p>
                    <ul>
                        <li>Kedvezményezett: Dentalcoop Plus Kft.</li>
                        <li>Számlaszám: 12094507-01372320-00100009</li>
                        <li>Összeg: {amount}</li>
                        <li>Közlemény: Rendelés azonosító: {orderId}</li>
                    </ul>
                    

                </div>
            )}
        </div>
    </div>
  )
}

export default OrderConfirmation